import React from 'react';

import { Translate } from '@hydra/common/components';

interface HelpTextProps {
  content: string
  component?: string
}

export const HelpText = ({ content, component = 'span' }: HelpTextProps) => {
  return <Translate content={content} component={component} />;
};

export default HelpText;
